import { useTheme } from '@mui/material';
import { Theme } from '@mui/system';

import AppleIconMono from './svg/appleIconMono.svg';
import { EMlpIconVariant } from './Google';

export interface IAppleIconProps {
	variant?: EMlpIconVariant;
	size?: number;
}

const getAppleIconColors = (variant: EMlpIconVariant, theme: Theme): string => {
	switch (variant) {
		case EMlpIconVariant.Primary:
			return theme.palette.primary.main;
		case EMlpIconVariant.PrimaryVariation:
			return theme.palette.solutions[600];
		case EMlpIconVariant.Secondary:
			return theme.palette.neutral.main;
		case EMlpIconVariant.Disabled:
			return theme.palette.solutions[800];
		case EMlpIconVariant.BrandColors:
		default:
			return theme.palette.common.black;
	}
};

export const AppleIcon = ({
	variant = EMlpIconVariant.BrandColors,
	size = 24,
}: IAppleIconProps) => {
	const theme = useTheme();
	const color = getAppleIconColors(variant, theme);

	return (
		<AppleIconMono
			width={size}
			height={size}
			style={{ display: 'block' }}
			fill={color}
		/>
	);
};
